// extracted by mini-css-extract-plugin
export default {"CurrentIterationLabel":"iteration-group-header-label-module__CurrentIterationLabel--DTTZQ"};